<template>
  <v-data-table
    class="no-border"
    :items="filteredData"
    :headers="headers"
    :items-per-page="data.length + 1"
    hide-default-footer
    hide-default-header
    sort-by="date"
    :sort-desc="true"
    :loading="loading"
    dense
    no-data-text="Aucune perte ou expiration"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td width="180px" class="correction-td">
          <a
            style="cursor: pointer; color:rgba(0, 0, 0, 0.87);"
            class="font-capitalize caption"
            >{{ item.name }}</a
          >

          <v-row no-gutters dense v-if="$vuetify.breakpoint.xsOnly">
            <v-chip
              :color="item.type === 0 ? 'warning' : 'error'"
              small
              label
              class="block-chip my-1"
            >
              <div>
                <span class="ml-1 caption" v-if="item.type === 1">
                  {{ item.date | shortLocalFormat }}</span
                >
              </div>
              <div
                class="ml-1"
                style="min-width: 75px; display: flex; flex-grow: 1; align-items: center; justify-content: flex-end;"
              >
                <span v-if="item.type === 1" class="mr-1 font-weight-bold"
                  >Perte de</span
                >
                <span class="font-weight-bold">{{
                  item.quantity | round2
                }}</span>
                <span class="caption ml-1">{{ item.unit }}</span>
                <span
                  v-if="item.type === 0"
                  class="ml-2 font-weight-bold caption"
                  >Expire dans {{ item.threshold }} jours</span
                >
                <span class="caption ml-2" style="width: 48px; text-align: end;"
                  >{{ item.correction_value }}$</span
                >
              </div>
            </v-chip>
          </v-row>
        </td>
        <td v-if="$vuetify.breakpoint.smAndUp">
          <v-chip
            :color="item.type === 0 ? 'warning' : 'error'"
            small
            label
            class="block-chip my-1"
          >
            <div>
              <span class="ml-1 caption" v-if="item.type === 1">
                {{ item.date | shortLocalFormat }}</span
              >
            </div>
            <div
              class="ml-1"
              style="min-width: 75px; display: flex; flex-grow: 1; align-items: center; justify-content: flex-end;"
            >
              <span v-if="item.type === 1" class="mr-1 font-weight-bold"
                >Perte de</span
              >
              <span class="font-weight-bold">{{ item.quantity | round2 }}</span>
              <span class="caption ml-1">{{ item.unit }}</span>
              <span v-if="item.type === 0" class="ml-2 font-weight-bold caption"
                >Expire dans {{ item.threshold }} jours</span
              >
              <span class="caption ml-2" style="width: 48px; text-align: end;"
                >{{ item.correction_value }}$</span
              >
            </div>
          </v-chip>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";
import { round10 } from "round10";
import { mapGetters } from "vuex";
export default {
  name: "InventoryExpirationAndWasteGrid",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filter: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getExpirations", "getWastes", "getProducts"]),
    data() {
      const d = [
        ...this.getExpirations
          .filter(
            x =>
              x.expiration_threshold !== 0 &&
              moment(x.expiration_date).diff(moment(), "days") <=
                x.expiration_threshold
          )
          .map(x => {
            const p = this.getProducts.find(p => p.id === x.product);
            if (p !== undefined) {
              return {
                id: x.id,
                date: x.production_date,
                name: p.nom,
                quantity: x.quantity,
                threshold: Math.ceil(
                  moment(x.expiration_date).diff(moment(), "hours") / 24
                ),
                unit: p.data.unite_mesure_inventory,
                type: 0,
                productId: x.product,
                correction_value: Math.abs(
                  round10(
                    Number(x.quantity) * Number(p.data.prix_inventory),
                    -2
                  )
                )
              };
            }
          })
          .filter(e => e !== undefined),
        ...this.getWastes
          .map(x => {
            const p = this.getProducts.find(p => p.id === x.fk_product);
            if (p !== undefined) {
              return {
                id: x.id,
                date: x.date,
                name: p.nom,
                quantity: Math.abs(x.quantity),
                threshold: 0,
                unit: p.data.unite_mesure_inventory,
                type: 1,
                productId: x.fk_product,
                correction_value: Math.abs(
                  round10(
                    Number(x.quantity) * Number(p.data.prix_inventory),
                    -2
                  )
                )
              };
            }
          })
          .filter(e => e !== undefined)
      ];
      return d;
    },
    filteredData() {
      let d = this.data;
      if (this.filter.showExpiration === false) {
        d = d.filter(x => x.type !== 0);
      }
      if (this.filter.showWaste === false) {
        d = d.filter(x => x.type !== 1);
      }
      return d;
    }
  },
  data() {
    return {
      headers: [{ value: "date" }, { value: "value" }]
    };
  }
};
</script>

<style></style>
